var _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMood4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M372.42,733.97c-6.19,0-12.4-.16-18.62-.48-94.7-4.86-181.83-46.31-245.36-116.7C44.93,546.39,12.62,455.47,17.48,360.77c4.86-94.7,46.31-181.83,116.7-245.35C204.58,51.9,295.5,19.59,390.2,24.45c94.7,4.86,181.83,46.31,245.35,116.7,63.52,70.4,95.83,161.32,90.97,256.01-4.86,94.7-46.31,181.83-116.7,245.36-65.77,59.35-149.45,91.45-237.39,91.45ZM371.81,60.95c-167.95,0-308.7,132.11-317.41,301.72-4.35,84.83,24.59,166.29,81.5,229.35,56.91,63.07,134.97,100.2,219.8,104.55,84.87,4.36,166.29-24.59,229.35-81.5,63.07-56.91,100.2-134.97,104.55-219.8,8.99-175.12-126.17-324.91-301.3-333.9-5.52-.28-11.03-.42-16.49-.42Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 224.63,
    cy: 374.33,
    r: 41.77
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 519.36,
    cy: 374.33,
    r: 41.77
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373,545.73c-52.95,0-103.47-25.77-130.63-67.29-4.91-7.51-2.81-17.58,4.7-22.49,7.51-4.91,17.58-2.81,22.49,4.7,22.51,34.41,66.08,54.98,110.95,52.37,64.14-3.71,94.76-52.03,96.03-54.09,4.72-7.63,14.73-9.99,22.36-5.26,7.63,4.72,9.99,14.73,5.26,22.36-1.64,2.64-40.98,64.75-121.78,69.42-3.13.18-6.26.27-9.38.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood4);
export default __webpack_public_path__ + "static/media/mood4.926aecfe99b9b2aef1e826cfd898c717.svg";
export { ForwardRef as ReactComponent };